if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				if(this.form) {
					this.form.querySelector("[name=id]").disabled = false;
					this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				}
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (this.submitButton) {
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");
			}
				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				let absoluteStoredResponse;
			

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						absoluteStoredResponse = response;
			

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');


						// Absolute addition #########
						if(typeof(absoluteStoredResponse.selling_plan_allocation)!== "undefined") {
							// work around to correct that if a variant with a bag of 5 is added to the cart, Shopify adds it as a quantity of 5 so the price is for 25 bags
							// change the quantity to 1, and add a hidden property so more can be added with the same options if needed:
							var formData = new FormData();
							formData.append("updates["+absoluteStoredResponse.id+"]", 1);
							fetch(window.Shopify.routes.root + 'cart/update.js', {
							  method: 'POST',
							  body: formData
							})
							.then(response => response.json())
							.then(data => {
								if(typeof(Shopify.formatMoney) !== "undefined") {
									document.querySelector('.cart-drawer__footer .totals__subtotal-value').innerHTML =  Shopify.formatMoney(data.items_subtotal_price,"£{{amount}}");
								}
								
								document.querySelector('.cart-drawer .cart-drawer-container em').innerHTML = "("+data.item_count+")";
								document.querySelector('.cart-count-bubble span[aria-hidden]').innerHTML = "("+data.item_count+")";

							});
						}
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

$(function() {
	if($('.featured_product_toggle').length>0) {
		$('.featured_product_toggle').click(function(e) {
			if(e) {
				e.preventDefault();
			}
			$(this).parents(".shopify-section.product-section").hide().siblings(".shopify-section.product-section").show();
		});
		$(".shopify-section.product-section:not(:first)").hide();
	}

	// Absolute addition:
	$( "#customisedMessage" ).on( "change keyup paste", function() {
		var characterLimit = $(this).attr('maxlength');
		var countRemaining = characterLimit - parseInt($(this).val().length);
		var remainingStringTranslation = $(this).next().attr('data-current').replace('##count##', countRemaining);
		$(this).next().text(remainingStringTranslation);	
	} );



});
